import axios from 'axios';
import { getUserData } from './storageService';

const BASE_URL = process.env.REACT_APP_API_URL || 'https://backend-c-0mxm.onrender.com';
const API_URL = BASE_URL.replace(/\/api$/, '');

const getAuthHeaders = () => {
  const user = getUserData();
  return {
    Authorization: `Bearer ${user?.userId || ''}`
  };
};

const api = axios.create({
  baseURL: `${API_URL}/api/planning`,
});

api.interceptors.request.use((config) => {
  config.headers = { ...config.headers, ...getAuthHeaders() };
  return config;
});

const planningService = {
  // Get all planning items
  getAll: async (filters = {}) => {
    const params = new URLSearchParams();
    Object.entries(filters).forEach(([key, value]) => {
      if (value) params.append(key, value);
    });
    const response = await api.get(`/?${params.toString()}`);
    return response.data;
  },

  // Get statistics
  getStats: async () => {
    const response = await api.get('/stats');
    return response.data;
  },

  // Upload file
  uploadFile: async (file, data) => {
    const formData = new FormData();
    formData.append('file', file);
    Object.entries(data).forEach(([key, value]) => {
      if (key === 'tags') {
        formData.append(key, JSON.stringify(value));
      } else {
        formData.append(key, value);
      }
    });
    const response = await api.post('/upload', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
  },

  // Add link
  addLink: async (data) => {
    const response = await api.post('/link', data);
    return response.data;
  },

  // Update item
  update: async (id, data) => {
    const response = await api.put(`/${id}`, data);
    return response.data;
  },

  // Delete item
  delete: async (id) => {
    const response = await api.delete(`/${id}`);
    return response.data;
  },

  // Get download info and track download
  getDownloadUrl: async (id) => {
    const response = await api.get(`/download/${id}`);
    return response.data;
  },

  // Track view
  trackView: async (id) => {
    await api.post(`/${id}/view`);
  },

  // Get file icon based on type
  getFileIcon: (fileType) => {
    if (!fileType) return 'file';
    if (fileType.includes('pdf')) return 'pdf';
    if (fileType.includes('excel') || fileType.includes('spreadsheet')) return 'excel';
    if (fileType.includes('word') || fileType.includes('document')) return 'word';
    if (fileType.includes('powerpoint') || fileType.includes('presentation')) return 'ppt';
    if (fileType.includes('image')) return 'image';
    return 'file';
  },

  // Format file size
  formatFileSize: (bytes) => {
    if (!bytes) return '0 B';
    const k = 1024;
    const sizes = ['B', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(1)) + ' ' + sizes[i];
  },
};

export default planningService;
